export default function CategoryAndProductTHead() {
    return (
        <div className='px-2 bg-gray-300 text-gray-900 rounded py-1.5 mb-2'>
            {/* <div className='grid [grid-template-columns:2fr_1fr_0.5fr_0.5fr_auto] gap-3 w-full text-[12px] items-center'>
                <p>Name</p>
                <p>Available</p>
                <p>Size</p>
                <p>Amount</p>
            </div> */}
            <div className='grid grid-cols-12 gap-2 w-full text-[12px] items-center'>
                <p className='col-span-4'>Name</p>
                <p className='col-span-2'>Available</p>
                <p className='col-span-1'>Size</p>
                <p className='col-span-2'>Price</p>
                <p className='col-span-3'>Addons</p>
            </div>
        </div>
    )
}
